import { camelcaseKeys } from 'src/utils/camelize-keys';
import { timestampToDate } from 'src/utils/dateFormatter';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { AssignedResource, GroupResource, Resource } from './_types';

const groupResourceReadOnlyFields = [
  'tags',
  'embed_url',
  'thumbnail',
  'large_thumbnail',
  'link',
];

export const normalizeResource = (resource): Resource => {
  return camelcaseKeys(resource, { deep: true }) as Resource;
};

export const normalizeAssignedResource = (
  assignedResource
): AssignedResource => {
  return camelcaseKeys(assignedResource, { deep: true }) as AssignedResource;
};

export const denormalizeResource = (resource): Resource => {
  return decamelizeKeys(resource, { deep: true }) as Resource;
};

export const denormalizeGroupResource = (groupResource): GroupResource => {
  const data = decamelizeKeys(groupResource, { deep: true }) as any;

  data.cached_link = data.link;
  removeReadOnlyFields(data, groupResourceReadOnlyFields);

  return data as GroupResource;
};

export const normalizeGroupResource = (groupResource): GroupResource => {
  return camelcaseKeys(
    {
      ...groupResource,
      created_at: timestampToDate(groupResource.created_at),
      updated_at: timestampToDate(groupResource.updated_at),
      expires_at: groupResource.expires_at
        ? timestampToDate(groupResource.expires_at)
        : null,
    },
    { deep: true }
  ) as GroupResource;
};
